function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import scales from "../foundations/scales";
import icon from "./icons";
const spacing = {
    'spacing.2xs': scales[0.125],
    'spacing.xs': scales[0.25],
    'spacing.s': scales[0.5],
    'spacing.m': scales[0.75],
    'spacing.l': scales[1],
    'spacing.xl': scales[1.5],
    'spacing.2xl': scales[2],
    'spacing.3xl': scales[3]
};
const inputGroupSpacing = {
    'inputGroup.padding.s': `calc(
		${spacing['spacing.s']} + ${icon['icon.m']} + ${spacing['spacing.xs']})`,
    'inputGroup.padding.m': `calc(
		${spacing['spacing.l']} + ${icon['icon.m']} + ${spacing['spacing.s']})`
};
export default _object_spread({}, spacing, inputGroupSpacing);

//# sourceMappingURL=spacing.js.map